import api from '~api/index'
var moduleA = {
  state: {
    dict:[],
    onSchool: '',
    code: '',
    lgInformation: null,
    loginData: {
      dialog: false
    }
  },
  mutations: {
    upErrordata: function (state, data) {
      //
      state.onSchool = data
    },
    upCodedata: function (state, data) {
      //
      state.code = data
    },
    uplgInformation: function (state, data) {
      //
      state.lgInformation = data
    },
    uploginData: function (state, data) {
      //
      state.loginData = data
    },
    setDataDictionary(state, data) {
      state.dict = data;
    },
  },
  actions: {
    upErrordata: function (context, data) {
      context.commit('upErrordata', data)
    },
    uplgInformation: function (context, data) {
      context.commit('uplgInformation', data)
    },
    uploginData: function (context, data) {
      context.commit('uploginData', data)
    },
    upCodedata: function (context, data) {
      context.commit('upCodedata', data)
    },
    async fetchDataDictionary(context) {
      await api.RESTful('index/dict').then(res => {
        if (1==1) {
          context.commit('setDataDictionary', res);
        }
      })
    }
  }
}
export {moduleA}



//////////////////
// WEBPACK FOOTER
// ./store/model/configdata.js
// module id = null
// module chunks = 